export const pagesMarkdownEN = {
  'en-service-maintenance': `# Service and maintenance of your installations

An annual inspection extends the life of your heating system, lowers running costs and catches faults before they become expensive damage. Sign a service agreement and let us remember for you.

[Get a free quote](/en/get-a-quote) [Call +45 75 33 12 76](tel:+4575331276)

## Service agreements for homes and businesses

With a service agreement we automatically come by once a year and go through your system. You get a fixed low price for the inspection, priority call-out for faults and a discount on spare parts.

| Service agreement | Includes |
| --- | --- |
| Heat pump | Annual inspection, statutory refrigerant check, cleaning of filters and outdoor unit, operation check |
| District heating | Inspection of unit, cleaning of dirt separator, check of cooling and balancing |
| Gas boiler | Statutory service, cleaning of burner and check of flue |
| Ventilation | Filter change, cleaning and check of heat recovery |

The price of a service agreement depends on the system and scope – contact us for a no-obligation quote.

## Why maintenance pays

- A serviced heating system typically uses 5–10 % less energy
- Manufacturer warranties on heat pumps often require a documented annual service
- Worn seals and valves are found before they cause water damage
- The lifetime of the system is extended by several years

## Plumbing inspection of the whole house

Buying or selling a house, or are your installations simply old? We offer a full plumbing inspection covering water, drainage, heating and hot water, with a prioritised list of what should be done. Read more about [renovating pipework](/en/plumbing/pipework-water-damage).

Is a gas boiler service mandatory?

Yes, gas boilers must be inspected regularly by an authorised installer – typically every year or every other year depending on the type.

Can I cancel the service agreement?

Yes, the agreement runs for one year at a time and can be cancelled with one month's notice before expiry.`,

  'en-sheet-metal': `# Sheet-metal work in Billund – gutters, flashings and zinc

Our sheet-metal workers handle everything from gutters, downpipes and flashings to façade cladding in zinc, copper and aluminium – craftsmanship that keeps water and weather out for decades.

[Get a free quote](/en/get-a-quote) [Call +45 75 33 12 76](tel:+4575331276)

## Sheet-metal work on roofs and façades

The sheet-metal trade is about guiding water to the right place. Leaking gutters, poor flashings around chimneys and rooflights or rusty valley gutters quickly lead to damp damage in the roof structure. We make new and repair old – on houses, farms, commercial buildings and new builds.

## We offer

- New gutters and downpipes in zinc, copper, aluminium and plastic
- Cleaning and repair of existing gutters
- Flashings around chimneys, rooflights, dormers and vents
- Valley gutters and eaves flashings
- Zinc and copper roofs and façade cladding
- Window sills, wall copings and bargeboards
- Vent cowls for ventilation and cooker hoods

## Zinc, copper or aluminium?

| Material | Lifetime | Characteristics |
| --- | --- | --- |
| Zinc | 40–60 years | Classic Danish look, weathers to grey, good value |
| Copper | 80–100+ years | Weathers to green, extremely durable, higher price |
| Aluminium | 30–40 years | Light, available in colours, maintenance-free |
| Plastic | 15–25 years | Cheapest, suitable for sheds and carports |

## Metalwork

Besides plumbing and sheet metal we carry out light metalwork – steel pipe runs, brackets, fittings and repairs related to heating and ventilation installations.

## Sheet-metal work in Billund, Grindsted, Give and Vejle

We work throughout Billund Municipality and the surrounding area. If you combine sheet-metal work with a roof renovation, we are happy to coordinate with your carpenter so the flashings are made while the scaffolding is up.

What do new gutters cost?

It depends on material, roof height and access. Prices vary from job to job, so we are happy to give you a [no-obligation quote](/en/get-a-quote) after a free site visit.

How often should gutters be cleaned?

At least once a year – ideally after the leaves have fallen. If there are large trees close to the house, twice a year.`,

  'en-about': `# About Billund Varme & Sanitet A/S

The company was founded in 1963. Mogens Brøgger qualified as a plumbing installer in 2011, took over the company in 2012 and today has more than 25 years of experience in the trade.

[Get a free quote](/en/get-a-quote) [Call +45 75 33 12 76](tel:+4575331276)

## Your local plumber since 1963

Billund Varme & Sanitet A/S has many years of experience with every type of job in the plumbing trade. We help everyone – from private individuals to companies, associations and institutions. In other words, we can help whether you need a new heating supply, renovated pipework or a rebuilt bathroom.

- **1963** founded in Billund
- **60+** years of plumbing experience
- **2012** taken over by Mogens Brøgger
- **24/7** emergency service all year

## We are not satisfied until the customer is

Our focus is always on delivering exactly the work each customer needs. No more, no less. That means honest advice – also when the cheapest option is to repair rather than replace – and technicians who clean up after themselves and keep the appointments we make.

## Authorised and insured

Billund Varme & Sanitet A/S is an authorised plumbing installer (CVR 29407320). All work on water, drainage and gas installations is carried out by trained technicians and documented, so you are covered with your insurer, the municipality and any future buyer of your home.

## Mogens Brøgger – owner and installer

Mogens qualified as a plumbing installer in 2011 and took over the company in 2012. He still handles quotes, site visits and day-to-day management himself – and he is not afraid to pick up the tools. If you have questions about a job, Mogens is the one you talk to.

## What we do

We carry out [plumbing](/en/plumbing), [heat pumps](/en/heating/heat-pumps), [district heating](/en/heating/district-heating), [bathrooms](/en/plumbing/bathrooms), [sheet-metal and metalwork](/en/sheet-metal), [new construction](/en/new-construction) and [service](/en/service-maintenance) throughout Billund Municipality and the surrounding area. See our [references](/en/references), or read about [jobs and apprenticeships](/en/careers).`,

  'en-heating-heat-pumps': `# Heat pumps in Billund – installation, grants and service

A heat pump is the cheapest and most climate-friendly heating for most houses without district heating. We deliver complete heat-pump systems with ongoing service and professional heating control.

[Get a free quote](/en/get-a-quote) [Call +45 75 33 12 76](tel:+4575331276)

## Air-to-water heat pump – replace the oil or gas boiler

An air-to-water heat pump extracts energy from the outdoor air and delivers it to your radiators, underfloor heating and hot water. For every kWh of electricity it uses, it typically delivers 3–4 kWh of heat. Switching from an oil boiler can cut your annual heating cost by 40–60 %.

- **3–4×** more heat than electricity used (SCOP)
- **40–60 %** lower heating bill than an oil boiler
- **15–20 yrs** expected lifetime with service
- **1–2 days** installation time in a detached house

## We help all the way

- Free site visit and sizing based on the heat demand of your house
- Advice on choice of heat pump and placement of the outdoor unit (noise limits)
- Application for grants from the Danish Energy Agency's heat-pump scheme when open
- Removal and disposal of the old boiler and oil tank
- Installation, commissioning and instruction in operation
- Service agreement with annual inspection and statutory refrigerant check

## Air-to-air heat pumps for holiday homes and extensions

For holiday homes, workshops and rooms with electric heating, an air-to-air heat pump is often the best solution. It heats in winter, cools in summer and is installed in half a day.

## What does a heat pump cost?

The price depends on the heat demand of the house, the choice of heat pump and the existing system – so it varies from job to job. We calculate the heat demand at a free site visit and give you a [no-obligation quote](/en/get-a-quote) for your house. See also our [guide to what affects the price](/en/guides/heat-pump-cost).

## Heat pump or district heating?

In parts of Billund and Grindsted, [district heating](/en/heating/district-heating) is available. We advise impartially on what is best for you – see the comparison in [District heating or heat pump?](/en/guides/district-heating-or-heat-pump)

Can a heat pump heat an older house with radiators?

Yes, in the vast majority of cases. We calculate the heat demand and check that the radiators are large enough for the lower flow temperature. Occasionally a single radiator needs replacing.

Is a heat pump noisy?

Modern heat pumps emit 35–45 dB(A) at a few metres. We position the outdoor unit so that the noise limit at the boundary is respected.

How often does a heat pump need servicing?

We recommend an annual inspection. Systems with more than 1 kg of refrigerant must also be checked annually by a certified technician – included in our service agreement.`,

  'en-heating-heating-systems': `# Heating systems, underfloor heating and boiler replacement

We install and renovate all types of heating systems – radiators, underfloor heating, hot-water cylinders and controls – and help you move on when the oil or gas boiler is due for replacement.

[Get a free quote](/en/get-a-quote) [Call +45 75 33 12 76](tel:+4575331276)

## Time to replace the oil or gas boiler?

Oil boilers may no longer be installed in areas with district heating or natural gas, and natural gas is being phased out towards 2035. If your boiler is over 15 years old, it is time to plan its successor. We go through the options with you – [heat pump](/en/heating/heat-pumps), [district heating](/en/heating/district-heating) or, in special cases, a new condensing gas boiler as a transitional solution.

## Underfloor heating – comfort and low flow temperature

Underfloor heating gives an even warmth and pairs perfectly with heat pumps and district heating because it runs at a low temperature. We install wet underfloor heating in new builds, extensions and when renovating bathrooms and kitchens – in concrete as well as lightweight floor constructions.

## Radiators and hot-water cylinders

- Replacing old radiators with low-temperature radiators
- Thermostatic valves and balancing of the whole system
- New hot-water cylinders and instantaneous water heaters
- Energy-efficient circulation pumps
- Weather compensation and smart heating controls

## Professional heating control

A correctly set heating system can save 10–15 % on the heating bill without compromising comfort. We balance the system, set the heating curve and time schedules, and show you how to use the controls – including via app.

Can I get a grant for scrapping my oil boiler?

The Danish Energy Agency regularly opens schemes for replacing oil and gas boilers with heat pumps. We stay up to date and help with the application when a scheme is open.

Can underfloor heating be laid on top of an existing floor?

Yes, with low-profile systems of 15–30 mm. It is a good solution for renovations where the old floor is not being broken up.`,

  'en-plumbing-ventilation': `# Ventilation and a better indoor climate

We install and renovate ventilation systems so you get a healthy indoor climate – without damp, mould and condensation on the windows.

[Get a free quote](/en/get-a-quote) [Call +45 75 33 12 76](tel:+4575331276)

## Ventilation systems for homes and businesses

Modern, airtight houses need mechanical ventilation to remove moisture and CO₂. A balanced ventilation system with heat recovery changes the air throughout the home and reuses up to 90 % of the heat in the extracted air. The result is fresh air, lower heating bills and fewer problems with damp and allergies.

## What we do

- Balanced ventilation with heat recovery in new builds and existing houses
- Extraction from kitchens, bathrooms and utility rooms
- Ventilation for commercial premises, institutions and production buildings
- Filter changes, cleaning and balancing of existing systems
- Decentralised ventilation units for single rooms

## Signs that you need ventilation

Condensation on the inside of windows in the morning, mould in bathroom grout, heavy air in the bedroom and lingering smells are all signs of too little air change. The Danish building regulations require an air change of at least 0.3 l/s per m² in new homes – roughly all the air in the house every two hours.

## Ventilation and heat pumps go together

If you are also considering a [heat pump](/en/heating/heat-pumps), it makes sense to plan ventilation from the start. An airtight, well-insulated house with good ventilation gives the heat pump the best conditions and the lowest running cost.

What does a ventilation system for a house cost?

It depends on the size of the house and how easily the ducts can be routed. Prices vary from job to job, so we are happy to give you a [no-obligation quote](/en/get-a-quote) after a free site visit.

How often should the filters be changed?

Usually every 6–12 months. We offer a [service agreement](/en/service-maintenance) where we change filters and inspect the system once a year.`,

  'en-commercial': `# Plumbing for business, housing associations and institutions

Downtime costs money. As your plumbing partner we keep your installations running reliably – with a service agreement, a dedicated technician and fast help when it is urgent.

[Get a free quote](/en/get-a-quote) [Call +45 75 33 12 76](tel:+4575331276)

## One plumbing partner for your whole property portfolio

We serve companies, housing associations, owners' associations, landlords and public institutions in Billund Municipality and the surrounding area. Our customers range from manufacturing companies and hotels around Billund to housing estates in Grindsted and institutions in Give – many of them international businesses with English-speaking facility managers.

## What you get as a commercial customer

- A dedicated technician who knows your buildings and installations
- Service agreement with scheduled inspections of heating, water, ventilation and hot-water systems
- Priority call-out for breakdowns – also outside office hours
- Legionella prevention and temperature logging in hot-water systems
- Statutory inspections of heat pumps and cooling systems
- Renovation of risers, soil stacks and plant rooms in apartment buildings
- Consolidated invoicing and digital documentation per property

## Housing associations and property management

When renovating risers and bathrooms in occupied buildings, communication with residents is essential. We plan in stages, give plenty of notice and arrange temporary water supply so disruption is minimal.

## Industry and production

For manufacturing companies we deliver process piping, compressed air, cooling and heating systems and ventilation – and we work outside production hours when required.

**Would you like a quote for a service agreement?** Send an overview of your properties and installations to [info@billundvvs.dk](mailto:info@billundvvs.dk) and we will come back with a proposal.`,

  'en-heating-district-heating': `# District heating in Billund – connection and heat unit

District heating is simple, reliable and needs minimal maintenance. We handle the connection inside the house, install the heat unit and make sure the system runs at its best.

[Get a free quote](/en/get-a-quote) [Call +45 75 33 12 76](tel:+4575331276)

## District heating connection from A to Z

Once the utility has brought the service pipe into the house, we take over. We install the district heating unit with heat exchanger and hot-water cylinder or instantaneous water heater, connect the existing radiator or underfloor system and remove the old oil or gas boiler.

## We offer

- Installation of district heating units – direct or indirect systems
- Removal and disposal of oil, gas or pellet boilers
- Balancing radiators and underfloor heating for a low return temperature
- Replacement of older units and heat exchangers
- Fault-finding when there is no heat or hot water
- Service inspections and cleaning of dirt separators

## Avoid penalty tariffs with a low return temperature

Most district heating utilities charge according to how well you cool the water. If your system runs with a high return temperature, you pay extra. Balancing the radiator valves and setting the unit correctly can save several thousand kroner a year – one of the most overlooked savings in district heating areas.

## District heating in Billund Municipality

Billund Varmeværk and Grindsted Varmeværk supply large parts of both towns, and the network is being extended. If your house is outside the supply area, a [heat pump](/en/heating/heat-pumps) is usually the best alternative. See our comparison: [District heating or heat pump?](/en/guides/district-heating-or-heat-pump)

What does the installation inside the house cost?

It depends on the unit, the existing system and whether the old boiler has to be removed. Prices vary from job to job, so we are happy to give you a [no-obligation quote](/en/get-a-quote) after a free site visit. The utility's connection fee is additional.

Does my hot-water cylinder need replacing?

Not necessarily. If the cylinder is under 10 years old and in good condition, it can often be reused. We assess this at the site visit.`,

  'en-faq': `# Frequently asked questions

Here we have collected answers to the questions we are asked most often by customers in Billund and the surrounding area. If you cannot find an answer, call us on +45 75 33 12 76.

[Get a free quote](/en/get-a-quote) [Call +45 75 33 12 76](tel:+4575331276)

## Prices and quotes

What does a plumber cost per hour?

We always state our hourly rate before we start, and travel within Billund Municipality is included. Larger jobs are quoted at a fixed price after a free site visit.

Is the quote binding for me?

No. A quote from us is free and without obligation. Only when you accept it do we have an agreement.

Can I get the Danish home-improvement tax deduction?

Labour for a range of plumbing jobs qualifies for the Danish "servicefradrag". We split the invoice into labour and materials so you can easily claim it.

## Heating

When should I replace my oil or gas boiler?

If the boiler is over 15 years old, you should plan its replacement. See the options under [heating systems](/en/heating/heating-systems) and read the guide [District heating or heat pump?](/en/guides/district-heating-or-heat-pump)

How much can I save with a heat pump?

Typically 40–60 % compared with an oil boiler and 20–40 % compared with natural gas. See the [cost guide](/en/guides/heat-pump-cost).

Why do I have no hot water?

Often it is a faulty circulation pump, a scaled cylinder or a fault on the boiler. Call us – most faults are fixed on the first visit.

## Emergencies

What do I do about a burst pipe?

Turn off the main stopcock by the water meter and call our [emergency line](/en/plumbing/emergency) on +45 75 33 12 76.

Does insurance cover water damage?

Sudden damage such as burst pipes is usually covered. Damage from slow seepage rarely is. We provide the documentation your insurer needs.

## Practical

Where do you work?

Throughout Billund Municipality – [Billund](/en/plumber-billund), [Grindsted](/en/plumber-grindsted), [Sdr. Omme, Vorbasse, Hejnsvig](/en/plumber-soender-omme) – as well as [Give](/en/plumber-give) and [Vejle](/en/plumber-vejle).

Are you authorised?

Yes. Billund Varme & Sanitet A/S is an authorised plumbing installer, CVR 29407320.

Do you speak English?

Yes. We regularly work for international companies and families in the Billund area, and you are welcome to contact us in English.

What are your opening hours?

Monday–Thursday 7:00–16:00, Friday 7:00–13:00. Emergency service every day.`,

  'en-guides-district-heating-or-heat-pump': `# District heating or heat pump?

If you live in an area with district heating, the choice is not always obvious. Here we compare the two options on the points that matter for your finances and comfort.

[Get a free quote](/en/get-a-quote) [Call +45 75 33 12 76](tel:+4575331276)

## Comparison

| Feature | District heating | Air-to-water heat pump |
| --- | --- | --- |
| Investment | Unit + connection fee to the utility | Higher purchase cost – grants available |
| Annual heating cost | Depends on the utility's tariff | Depends on electricity price and insulation |
| Maintenance | Minimal – annual inspection recommended | Annual service inspection |
| Lifetime | Unit 20–25 years | 15–20 years |
| Space | Small wall-mounted unit | Outdoor unit in the garden + indoor unit/cylinder |
| Noise | None | 35–45 dB(A) from the outdoor unit |
| Climate | Depends on the utility's fuel | Greener as the grid gets greener |

## Choose district heating if …

- Your house is within the supply area of Billund or Grindsted Varmeværk
- You want a solution with no maintenance and no noise
- You have a small plot or neighbours close by

## Choose a heat pump if …

- District heating is not available – or not for many years
- Your house is reasonably insulated and has underfloor heating or large radiators
- You have or plan to install solar panels
- You can obtain a grant from the heat-pump scheme

## Our recommendation

If district heating will be available within 1–2 years, it is the simplest solution for most people. If district heating is not on the way, a heat pump is clearly the best choice. We advise impartially – we install both. Read more about [district heating](/en/heating/district-heating) and [heat pumps](/en/heating/heat-pumps), or [book a site visit](/en/get-a-quote).`,

  'en-new-construction': `# Plumbing for all types of new construction

We deliver complete plumbing, heating and ventilation installations for new builds – from homes and commercial buildings to large projects and public institutions. On time, to the drawings and fully documented.

[Get a free quote](/en/get-a-quote) [Call +45 75 33 12 76](tel:+4575331276)

![Terraced housing under construction – plumbing by Billund Varme & Sanitet](/_assets/nybyg.jpg)

## Trusted plumbing partner for contractors, house builders and developers

New construction demands planning, documentation and precision. Our technicians are used to working to schedules with many trades on site, and we deliver the documentation the project requires – pressure test reports, QA material and as-built drawings.

## What we deliver in new builds

- Water, drainage and sanitary installations
- Underfloor heating, radiators and plant rooms
- Heat pumps and district heating connections
- Balanced ventilation with heat recovery
- Gutters, flashings and sheet-metal work
- Sprinkler and plant rooms in cooperation with specialists

## From detached house to institution

### Housing
Detached houses, terraced housing, holiday homes and apartment buildings – with house builders and private developers.

### Commercial
Warehouses, production, offices and retail – including the many commercial developments around Billund Airport.

### Public institutions
Schools, nurseries, care homes and sports facilities with legionella control and operational requirements.

### Agriculture
Farm buildings and plant rooms with robust installations for demanding environments.

## How we work on construction projects

1. **Quote based on drawings** We price the tender documents and propose optimisations where they make sense.
2. **Design and coordination** A dedicated contact who attends site meetings and coordinates with the other trades.
3. **Execution in stages** First fix, second fix and handover to schedule.
4. **Documentation and handover** Pressure testing, QA, operation and maintenance material.

After handover we offer [service agreements](/en/service-maintenance) so the systems perform throughout the building's life. See selected projects under [references](/en/references).`,

  'en-plumber-billund': `# Plumber in Billund – just around the corner

Billund Varme & Sanitet A/S is based at Montanavej 1B in Billund. From here we serve the town's houses, housing associations, the business parks by the airport and everything in between.

[Get a free quote](/en/get-a-quote) [Call +45 75 33 12 76](tel:+4575331276)

## Local plumbing contractor in Billund since 1963

We have been part of Billund since the town really started to grow. That means we know the houses, the installations and the local conditions – from the 1960s houses to the newest developments and the commercial buildings around Billund Airport and Lalandia.

## Plumbing services in Billund

- [All plumbing work](/en/plumbing) – taps, toilets, pipes and drains
- [Bathrooms](/en/plumbing/bathrooms) at a fixed price
- [Heat pumps](/en/heating/heat-pumps) and [district heating](/en/heating/district-heating) from Billund Varmeværk
- [Sheet-metal work](/en/sheet-metal) – gutters and flashings
- [Emergency plumbing 24/7](/en/plumbing/emergency) – we are there in minutes

## Businesses and international residents in Billund

Billund is home to some of Denmark's largest workplaces and a large number of hotels, holiday resorts and transport companies. We provide [service agreements and operations support](/en/commercial) to commercial properties across town, and we are used to working with English-speaking facility managers and families relocating to the area.

## Find us

Montanavej 1B, 7190 Billund – in the business park by Vejlevej, 5 minutes from the centre. There is parking at the door if you want to drop by to look at fittings or leave a key.`,

  'en-plumbing-emergency': `# Emergency plumber in Billund – on call 24/7

Water pouring out, drain blocked, or the boiler died in the middle of the night? Call +45 75 33 12 76. Our on-call technician responds around the clock throughout Billund Municipality.

[Get a free quote](/en/get-a-quote) [Call +45 75 33 12 76](tel:+4575331276)

Emergency line: [+45 75 33 12 76](tel:+4575331276)

Every day, all year. Outside normal hours an on-call surcharge applies – we tell you the price on the phone before we leave.

## What we respond to

- Burst or leaking water pipes and radiators
- Blocked drains, toilets and soil stacks
- Heating failure – boiler, heat pump or district heating unit not working
- Leaking hot-water cylinder or no hot water
- Frozen and burst pipes in winter
- Smell of gas – always call 112 first, then us

## While you wait for the technician

1. **Turn off the water** The main stopcock is by the water meter. Leaking radiator: close both valves on the radiator.
2. **Switch off power to the boiler** If water is dripping onto electrical installations.
3. **Take photos** Your insurer will ask for documentation of the damage.

## Fast response across the area

From our base in Billund it is under 20 minutes to Grindsted, Give, Sdr. Omme and Vorbasse – and around 30 minutes to Vejle. Our vans are fully equipped, so most emergencies can be fixed on the first visit.

See also our guide: [How to avoid frozen and burst pipes](/en/guides/frozen-pipes).

What does an emergency call-out cost?

We always state the hourly rate and on-call surcharge on the phone before we leave. There are no hidden fees.

Do you also come at weekends and on public holidays?

Yes. The emergency service covers every day of the year.`,

  'en-plumbing-pipework-water-damage': `# Pipework and water damage repair

Old iron pipes, leaking joints and hidden leaks are expensive. We renovate pipework in all types of buildings and respond quickly when the damage is done.

[Get a free quote](/en/get-a-quote) [Call +45 75 33 12 76](tel:+4575331276)

## Renovating pipework in older homes

Many houses in Billund, Grindsted and Give from the 1960s and 70s still have their original water pipes. After 40–50 years, iron and copper pipes corrode and the risk of leaks rises sharply. We can renovate any kind of installation – and we advise honestly on whether it pays to replace everything at once or in stages.

## We help with

- Replacing water pipes with modern PEX or copper
- New risers and distribution pipes in apartment blocks and housing associations
- Replacing drainage pipes and soil stacks
- Leak detection with pressure testing and thermal imaging
- Water-damage repair in cooperation with your insurer
- Fitting water-stop valves and leak alarms

## Water damage? Here is what to do

1. **Turn off the main stopcock** Usually next to the water meter in the utility or plant room.
2. **Call us on +45 75 33 12 76** We are on call 24/7 for emergencies throughout Billund Municipality.
3. **Contact your insurer** We provide the documentation and damage report your insurer needs.

## Prevent water damage

A water-stop valve automatically shuts off the supply when it detects abnormal consumption. Combined with an annual [plumbing inspection](/en/service-maintenance) it significantly reduces the risk of costly damage – and several insurers offer a premium discount.

When should water pipes be replaced?

Iron pipes should generally be replaced after 40–50 years, and always if there is rust in the water, falling pressure or damp patches.

Does insurance cover water damage?

Sudden damage such as burst pipes is normally covered by home insurance. Damage from slow seepage rarely is – another reason to have your installations checked.`,

  'en-privacy-policy': `# Privacy policy

Billund Varme & Sanitet A/S (CVR 29407320) is the data controller for the information you provide via this website or in connection with work we carry out for you.

[Get a free quote](/en/get-a-quote) [Call +45 75 33 12 76](tel:+4575331276)

## What information do we collect?

Name, address, phone number, email and details of the job you contact us about. The information is used solely to answer your enquiry, prepare a quote, carry out the work and invoice.

## Retention

Information about completed work is kept for 5 years after the end of the financial year in accordance with the Danish Bookkeeping Act. Enquiries that do not lead to a job are deleted after 12 months.

## Cookies

The website uses only necessary cookies and – with your consent – statistics cookies to improve the site.

## Your rights

You can at any time request access to, correction or deletion of your data by contacting us at [info@billundvvs.dk](mailto:info@billundvvs.dk). Complaints can be addressed to the Danish Data Protection Agency (Datatilsynet).`,

  'en-plumbing': `# Authorised plumber in Billund

Well-functioning plumbing matters at home and at work. We install, renovate and service all types of plumbing and heating – with fixed prices and a guarantee.

[Get a free quote](/en/get-a-quote) [Call +45 75 33 12 76](tel:+4575331276)

## All plumbing work from one authorised contractor

Billund Varme & Sanitet A/S has many years of experience with every type of job in the plumbing trade. We help private customers, businesses, associations and institutions – and we can renovate any kind of installation, from a single dripping tap to complete pipework in a new build.

- [**Bathrooms** \\\\\nFull renovation, new bathroom or shower enclosure – we manage the whole project.](/en/plumbing/bathrooms)
- [**Pipework & water damage** \\\\\nNew water pipes, replacement of old installations and repair of damage.](/en/plumbing/pipework-water-damage)
- [**Ventilation & indoor climate** \\\\\nInstallation and renovation of ventilation systems for homes and businesses.](/en/plumbing/ventilation)
- [**Emergency plumber – 24/7** \\\\\nBurst pipe, blocked drain or no heating? We are on call around the clock.](/en/plumbing/emergency)
- [**Heat pumps** \\\\\nAir-to-water and air-to-air heat pumps with service and grant applications.](/en/heating/heat-pumps)
- [**District heating** \\\\\nConnection, heat exchanger unit and optimisation of your system.](/en/heating/district-heating)

## Typical plumbing jobs we do every day

- Replacing taps, mixers, toilets and basins
- New water and drainage installations in kitchens and utility rooms
- Connecting dishwashers, washing machines and fridges with water dispensers
- Replacing hot-water cylinders and circulation pumps
- Radiators, underfloor heating and thermostats
- Statutory inspections and pressure testing of installations

## Avoid water damage – have your installations inspected

Water damage is among the most expensive damage in Danish homes. We can inspect your installations so that any problems are fixed in time. A plumbing inspection typically takes 1–2 hours and gives you a clear overview of what should be replaced now and what can wait.

## Save on your bills with modern installations

Old installations waste water and energy. Water-saving fittings, a new circulation pump or a correctly balanced heating system often pay for themselves within a few years. We always advise based on what makes sense for your home – not on what gives us the most work.

**Fixed-price quotes.** You are always welcome to contact us for a no-obligation quote. Smaller jobs are carried out on an hourly basis at our current rate; larger jobs at a fixed price.

## Frequently asked questions about plumbing

What does a plumber cost per hour in Billund?

We always state our hourly rate before starting, and travel within Billund Municipality is included. Larger jobs such as bathrooms and heat pumps are quoted at a fixed price.

Does plumbing work have to be done by an authorised installer?

Yes. In Denmark, work on water, drainage and gas installations may only be carried out by an authorised installer. Billund Varme & Sanitet A/S is authorised, and you receive documentation for the work.

How quickly can you come?

For emergencies we are on call 24/7. Planned jobs can typically start within 1–2 weeks.`,

  'en-careers': `# Jobs and apprenticeships

We are a local firm with varied jobs, regular customers and a flat structure where you talk directly to the boss. We are always looking for skilled plumbers and apprentices.

[Get a free quote](/en/get-a-quote) [Call +45 75 33 12 76](tel:+4575331276)

## Plumbing technician

You are a qualified plumber, can work independently and want a working day that mixes service calls, bathrooms, heat pumps and new builds. You get your own service van, modern tools and the opportunity for further training in heat pumps, district heating and ventilation.

## Plumbing apprentice

We take on apprentices because we believe in training the trade's future locally. As an apprentice with us you cover the whole trade and get an experienced plumber as your mentor. We work with the vocational colleges in Vejle and Esbjerg.

## What we offer

- Pay according to the collective agreement, plus pension
- Service van, phone and workwear
- Varied jobs – no two days alike
- Short path from idea to decision
- Fridays off at 1 pm

**Send an unsolicited application** to [info@billundvvs.dk](mailto:info@billundvvs.dk) – or call Mogens on +45 75 33 12 76 for a chat.`,

  'en-plumber-vejle': `# Plumber for Vejle and the surrounding area

Vejle is 30 minutes from Billund, and we regularly work in Vejle West, Jelling, Bredsten, Skibet and Vandel – particularly on larger projects, bathrooms and commercial jobs.

[Get a free quote](/en/get-a-quote) [Call +45 75 33 12 76](tel:+4575331276)

## Why choose a plumber from Billund for jobs in Vejle?

Because you get a fixed price, a dedicated technician and a company that has existed since 1963. We are happy to travel to Vejle for planned jobs – travel is included in the quote, so the price is the same as if we were next door.

## Jobs we do in the Vejle area

- [Bathroom renovation](/en/plumbing/bathrooms) as a turnkey project
- [Heat pumps](/en/heating/heat-pumps) for homes without district heating in the Vejle river valley and Vejle West
- [Plumbing for new builds](/en/new-construction) – we are a regular partner for several construction firms in the Triangle Region
- [Commercial service](/en/commercial) and service agreements for properties in Vejle
- [Sheet-metal work](/en/sheet-metal) – zinc roofs and gutters

## Emergency help in Vejle

For emergencies we primarily serve Billund Municipality, but always call – if the on-call technician is nearby, we also come to Vejle. See [emergency plumbing](/en/plumbing/emergency).`,

  'en-guides-heat-pump-cost': `# What does a heat pump cost?

Short answer: it varies from house to house. Here we go through what affects the price of a heat pump, which grants you can apply for, and how to get an accurate quote.

[Get a free quote](/en/get-a-quote) [Call +45 75 33 12 76](tel:+4575331276)

## What affects the price

- **The heat demand of the house.** A well-insulated 130 m² house may manage with a 6 kW unit; an older 200 m² house needs 12–16 kW.
- **Hot water.** Cylinder size depends on the size of the household.
- **The existing system.** Radiators that are too small for a low flow temperature may need replacing.
- **Removing the old boiler and oil tank.** If the old oil tank has to be decommissioned, it is included in the quote.
- **Placement of the outdoor unit.** Long pipe runs and a foundation affect the price.

## So what does it cost?

Because every house is different, we do not give standard prices. The price varies from job to job, which is why we always visit and inspect the house before giving a [no-obligation quote](/en/get-a-quote) with a fixed price – so you know exactly what you get and what it costs.

## Grants

The Danish Energy Agency regularly opens schemes offering grants for replacing oil and gas boilers with heat pumps. The amount depends on the size of the house and the current heat source. The schemes are quickly exhausted, so it is important to have the quote and documentation ready before a scheme opens. We help with the whole application.

## Running costs and payback

A heat pump typically delivers 3–4 times as much heat as the electricity it uses. Switching from an oil boiler, the saving on the heating bill is often 40–60 % a year, and with grants and the reduced Danish electricity tax on heat-pump power, the investment pays back within a manageable number of years for most homeowners. We are happy to make a specific calculation for your house.

Want to know what it costs for your house? [Book a free site visit](/en/get-a-quote) and we will calculate the heat demand and give you a fixed price.

Read more about [our heat-pump solutions](/en/heating/heat-pumps), or compare with [district heating](/en/guides/district-heating-or-heat-pump).`,

  'en-plumber-grindsted': `# Plumber in Grindsted

Grindsted is the municipality's largest town, and we are here every day. From Billund it is under a quarter of an hour to Grindsted, so you get fast help and a local technician who knows the town's buildings.

[Get a free quote](/en/get-a-quote) [Call +45 75 33 12 76](tel:+4575331276)

## Plumbing work in Grindsted and the surrounding area

We carry out all types of plumbing, heating and sheet-metal work in Grindsted – for private customers, housing associations, institutions and businesses. Grindsted has many older apartment buildings and housing estates where we renovate risers, soil stacks and bathrooms in occupied buildings.

## Popular services in Grindsted

- [District heating connection](/en/heating/district-heating) and unit replacement in Grindsted Varmeværk's supply area
- [Heat pumps](/en/heating/heat-pumps) in the rural areas around Grindsted without district heating
- [Bathroom renovation](/en/plumbing/bathrooms) in houses and apartments
- [Service agreements](/en/commercial) for housing associations, schools and care homes
- [Emergency plumbing](/en/plumbing/emergency) – on call every day

## Agriculture and industry around Grindsted

The countryside around Grindsted is characterised by farming and manufacturing. We deliver robust installations for farm buildings and plant rooms and have experience with the special requirements of industry and food production.

See also our work in [Billund](/en/plumber-billund), [Give](/en/plumber-give) and [Sdr. Omme and Vorbasse](/en/plumber-soender-omme).`,

  'en-plumber-soender-omme': `# Plumber in Sdr. Omme, Vorbasse and Hejnsvig

We cover all the smaller towns and rural areas of Billund Municipality – Sdr. Omme, Vorbasse, Hejnsvig, Stenderup-Krogager and Filskov – with the same service and the same price as in Billund.

[Get a free quote](/en/get-a-quote) [Call +45 75 33 12 76](tel:+4575331276)

## Plumbing for town and country

Outside the larger towns, many homes and farms depend on their own installations: heat pump or boiler, private water supply and septic tank. We know the challenges that brings, and we drive throughout the municipality every day.

## What we help with

- [Replacing oil boilers with heat pumps](/en/heating/heat-pumps) – with grants
- Pressure systems, water treatment and private water supply
- Installations for farm buildings and outbuildings
- [Bathrooms](/en/plumbing/bathrooms) and [pipe renovation](/en/plumbing/pipework-water-damage) in older farmhouses
- [Gutters and flashings](/en/sheet-metal) on farm buildings
- [Emergency service](/en/plumbing/emergency) – also out in the country

## Vorbasse and Hejnsvig

From Billund it is 15 minutes to Vorbasse and 10 minutes to Hejnsvig. We have many regular customers in both towns, private homes as well as farms, and we know the local conditions – including the areas where district heating is not an option.

## Sdr. Omme and Filskov

In Sdr. Omme and Filskov we serve houses, businesses and institutions alike. Contact us for a [no-obligation quote](/en/get-a-quote), whether it is a dripping tap or a completely new heating system.`,

  'en-guides': `# Guides and good advice

We are happy to share what we know. Here you will find guides on heating, water and maintenance, written by our own installers.

- [Heating · 5 min **What does a heat pump cost?** \\\\\nWhat affects the price, which grants you can apply for, and how to get an accurate quote.](/en/guides/heat-pump-cost)
- [Winter · 3 min **How to avoid frozen and burst pipes** \\\\\nFive precautions before the frost – and what to do if the damage is done.](/en/guides/frozen-pipes)
- [Heating · 6 min **District heating or heat pump?** \\\\\nHow to choose the right heat source in Billund Municipality.](/en/guides/district-heating-or-heat-pump)`,

  'en-guides-frozen-pipes': `# How to avoid frozen and burst pipes

When the water in a pipe freezes, it expands by about 9 %. That is enough to burst both copper and plastic pipes. Here are five things you can do before the frost arrives.

[Get a free quote](/en/get-a-quote) [Call +45 75 33 12 76](tel:+4575331276)

## 1. Shut off and drain outdoor taps

Close the stop valve inside the house, open the outdoor tap and leave it open all winter. If you do not have a stop valve, we can fit a frost-proof outdoor tap.

## 2. Insulate pipes in cold rooms

Pipes in unheated crawl spaces, garages, outbuildings and lofts should be insulated with pipe lagging. In exposed spots a heating cable with a thermostat may be necessary.

## 3. Keep the heating on – even when you are away

Never set thermostats below frost protection (about 8–10 °C) when travelling in winter. Leave the doors to the utility room and bathroom ajar so the heat reaches the pipes.

## 4. Winterise the holiday home properly

Turn off the main stopcock, drain the pipes, hot-water cylinder, toilet cistern and traps, and pour antifreeze into the drains. We offer winter shutdown as a regular service in the holiday-home areas around Give and Vejle.

## 5. Know your main stopcock

Everyone in the household should know where the main stopcock is and how to close it. It can limit damage from thousands to hundreds of kroner.

## If the damage is done

1. **Turn off the main stopcock** And open a tap to release the pressure.
2. **Call the emergency line** [Emergency plumbing](/en/plumbing/emergency) – +45 75 33 12 76, every day.
3. **Document the damage** Take photos for the insurer before you mop up.`,

  'en-plumber-give': `# Plumber in Give

Give is 20 minutes from our workshop in Billund, and we have had customers in the town and the countryside around Give for decades. We arrive when we say we will.

[Get a free quote](/en/get-a-quote) [Call +45 75 33 12 76](tel:+4575331276)

## Plumbing, heating and sheet metal in Give

We help homeowners, farms, businesses and institutions in Give, Thyregod, Vonge, Givskud and the surrounding area with all kinds of plumbing. Many houses in the area have no district heating, so replacing oil and gas boilers with a [heat pump](/en/heating/heat-pumps) is one of the jobs we do most often in Give.

## What we help with in Give

- [Air-to-water heat pumps](/en/heating/heat-pumps) including grant applications
- [Underfloor heating and new heating systems](/en/heating/heating-systems)
- [New bathrooms](/en/plumbing/bathrooms) at a fixed price
- [Gutters and flashings](/en/sheet-metal) on houses and farm buildings
- [Pipe renovation and water damage](/en/plumbing/pipework-water-damage)
- [Emergency plumbing](/en/plumbing/emergency) – we respond around the clock

## Holiday homes

For the holiday homes around Give and the Vejle river valley we install air-to-air heat pumps, frost-protect installations and offer winter shutdown and spring start-up as a regular service.`,

  'en-references': `# References – selected projects

A selection of the jobs we have done for private customers, housing associations, businesses and public institutions in Billund Municipality and the surrounding area.

[Can we help you too? Get a quote →](/en/get-a-quote)

## Selected projects

### 24 terraced houses with underfloor heating and ventilation
**New build · Billund**
Complete plumbing contract incl. balanced ventilation and district heating connection for a house builder.

### Full renovation of a 1972 bathroom
**Bathroom · Grindsted**
New drain, underfloor heating, wet-room sealing, tiles and walk-in shower – delivered in 4 weeks at a fixed price.

### From oil boiler to air-to-water heat pump
**Heat pump · Give**
165 m² detached house. Grant applied for and approved, oil tank decommissioned and a noticeably lower heating bill.

### Service agreement for a 120-room hotel
**Commercial · Billund**
Legionella control, hot-water system and ventilation. Dedicated technician and quarterly inspections.

### Riser replacement in 36 apartments
**Housing association · Grindsted**
Staged renovation in an occupied building with temporary water supply and daily resident updates.

### Zinc roof and flashings on a villa
**Sheet metal · Vejle**
New standing-seam zinc roof on a dormer, valley gutters and zinc gutters in cooperation with a local carpenter.`,

  'en-plumbing-bathrooms': `# New bathroom in Billund – renovation at a fixed price

A new bathroom is one of the best investments in your home. We handle the entire renovation – from plumbing and drainage to tiling, electrics and fitting – with one point of contact and one fixed price.

[Get a free quote](/en/get-a-quote) [Call +45 75 33 12 76](tel:+4575331276)

## Bathroom renovation with us as main contractor

When we renovate your bathroom, we coordinate every trade. You get one contact person, one schedule and one combined quote. Our own plumbers handle water, drainage, underfloor heating and sanitaryware, while we work with trusted local tilers, electricians and carpenters from the Billund area.

## What is included in a bathroom from us

- Free site visit and advice on layout and materials
- Demolition and disposal of the old bathroom
- New water and drainage installations to current building regulations
- Wet-room membrane, underfloor heating and tiling
- Fitting of shower enclosure, toilet, basin, bath and taps
- Documentation for insurance and estate agents

## What does a new bathroom cost?

The price depends on size, choice of materials and how much the installations need to be moved – so it varies from job to job. Keeping the toilet and drain where they are usually saves both time and money. We are happy to visit, look at your bathroom and give you a [no-obligation quote](/en/get-a-quote) with a fixed price.

## How a bathroom renovation proceeds

1. **Site visit and sketch** We measure up, discuss your wishes and propose a layout that makes the most of the space.
2. **Fixed-price quote** You receive one quote covering all trades, with a schedule.
3. **Demolition and installations** New pipes, drains, underfloor heating and wet-room sealing.
4. **Tiling and fitting** The tiler lays the tiles and we fit the sanitaryware and taps.
5. **Handover** Walk-through, cleaning and documentation.

## Bathrooms in Billund, Grindsted, Give and Vejle

We renovate bathrooms throughout Billund Municipality and the surrounding area. See examples under [references](/en/references), or read about everything else we do in [plumbing](/en/plumbing).

Can you move the toilet to another wall?

Yes, in most cases. It requires a new drain and often breaking up the floor, which affects the price. We assess this at the site visit.

How long does a bathroom renovation take?

A full renovation typically takes 3–5 weeks. We agree a schedule before we start and make sure you have access to a toilet throughout.

Can I get the Danish home-improvement tax deduction?

Labour costs for plumbing work often qualify for the Danish "servicefradrag". We itemise labour and materials on the invoice so you can easily claim it.`
};
